import React from "react";
import KYouthFooter from "./footer/KYouthFooter";
import KYouthHeader from "./header/KYouthHeader";

const Layout = ({ children }) => {
  return (
    <>
      <main className="main-wrapper">
        <KYouthHeader />
        {children}
        <KYouthFooter />
      </main>
    </>
  );
};
export default Layout;
